import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39121f2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height", "fill"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "62.75",
      cy: "44.25",
      r: "7.375"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "47.919",
      y: "-4.103",
      transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -20.7107 50)",
      width: "4.163",
      height: "108.207"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M28,17.5h44c5.79,0,10.5,4.71,10.5,10.5v27.278l-13.143,9.015l14.369,14.369C84.85,76.694,85.5,74.424,85.5,72V28    c0-7.444-6.056-13.5-13.5-13.5H28c-2.423,0-4.694,0.65-6.662,1.773l2.224,2.224C24.912,17.864,26.413,17.5,28,17.5z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M60.926,70.075L40,50L17.5,68.047V28c0-1.587,0.364-3.088,0.998-4.438l-2.224-2.224C15.15,23.306,14.5,25.577,14.5,28v44    c0,7.444,6.056,13.5,13.5,13.5h44c2.424,0,4.694-0.65,6.662-1.773L63.349,68.413L60.926,70.075z" })
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "empty-image",
    style: _normalizeStyle({ 'min-height': $props.minHeight !== '' ? $props.minHeight : 'auto' })
  }, [
    (_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      width: $props.svgWidth,
      height: $props.svgHeight,
      fill: $props.svgColor
    }, _hoisted_3, 8, _hoisted_1))
  ], 4))
}